import styled from 'styled-components'

export default styled.section`
  align-items: center;
  background: #304760;
  display: flex;
  padding: 5em 0;

  /* Extra Small Devices, Phones */ 
  @media only screen and (max-width : 480px){
    padding: 2em 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/WhoWeAre.js